import React, { useMemo } from "react";
import { Button } from "components/ui/button";
import { Copy, MessageCircle } from "lucide-react";
import CopyText from "../CopyText"; // your reusable copy component
import { buildOrderSummaryHe, buildWaMeUrl } from "../../utils/orderShare";

const iconBtn = "h-8 w-8 rounded-full";

export default function OrderActions({ order, disabled = false }) {
  const message = useMemo(() => buildOrderSummaryHe(order), [order]);

  const waUrl = useMemo(() => buildWaMeUrl(order?.phone, message), [order?.phone, message]);

  const openWhatsApp = () => {
    if (!waUrl) return;
    window.open(waUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="flex items-center gap-1">
      {/* WhatsApp */}
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className={iconBtn}
        onClick={openWhatsApp}
        disabled={disabled || !order?.phone}
        aria-label="שלח הודעת וואטסאפ"
        title="שלח וואטסאפ"
      >
        {/* MessageCircle is neutral; if you want green WhatsApp look, add className text-green-600 */}
        <MessageCircle className="h-4 w-4" />
      </Button>

      {/* Copy order details */}
      <CopyText
        value={() => message}
        disabled={disabled}
        label="העתק פרטי הזמנה"
        copiedLabel="הועתק"
        buttonClassName={iconBtn}
        className=""
      >
        {/* We only want the icon button; children can be empty */}
        <span className="sr-only">העתק</span>
      </CopyText>

      {/* Optional: If you prefer the CopyText to show Copy icon explicitly, you can render it as child:
          But CopyText already includes icon button. If you want exact Copy icon here, I can provide a
          variant that accepts "renderButton". */}
    </div>
  );
}
